import axios from 'axios';
import sensorStore from './model';

export function getSensor() {
    axios.get('/zhgd/index/sensor')
        .then((data) => {
            sensorStore.setSensors(data.result);
        })
        .catch((e) => console.log(e));
}

export function getDeviceUser() {
    axios.get('/zhgd/laser/manager/deviceUser')
        .then((data) => {
            sensorStore.setDeviceUser(data.result);
        })
        .catch((e) => console.log(e));
}

export function getDeviceSn() {
    axios.get('/zhgd/laser/manager/deviceSn')
        .then((data) => {
            sensorStore.setDeviceSn(data.result);
        })
        .catch((e) => console.log(e));
}

export function getCurveDate({deviceUser, deviceSn, endInMillis, beginInMillis}) {
    return axios.get(`/zhgd/laser/manager/data/curveData?deviceUser=${deviceUser}&deviceSn=${deviceSn}&endInMills=${endInMillis || ''}&beginInMillis=${beginInMillis || ''}`)
        .then((data) => {
            sensorStore.setCurveData(data.result);
        })
        .catch((e) => console.log(e));
}
